/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import top_img from "../../assets/final-images/aboutpage/CDCHospital.png";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import imaging_acc_1 from "../../assets/final-images/homepage/imaging-accreditation/radsite.png";
import imaging_acc_2 from "../../assets/final-images/homepage/imaging-accreditation/imaging-accreditation-02.png";
import imaging_acc_3 from "../../assets/final-images/homepage/imaging-accreditation/imaging-accreditation-03.png";
import imaging_acc_4 from "../../assets/final-images/homepage/imaging-accreditation/imaging-accreditation-04.png";
import imaging_acc_5 from "../../assets/final-images/homepage/imaging-accreditation/imaging-accreditation-05.png";
import dr_image from "../../assets/final-images/aboutpage/Dr_Amin.jpg";
import dr_samir from "../../assets/final-images/aboutpage/Dr_Samin.jpg";
import fatguy from "../../assets/final-images/aboutpage/Featured_Services/Artboard 1.jpg";
import care from "../../assets/final-images/aboutpage/Featured_Services/Artboard 2.jpg";
import MRIABD from "../../assets/final-images/aboutpage/Featured_Services/Artboard 3.jpg";
import PETImage from "../../assets/final-images/aboutpage/Featured_Services/Artboard 4.jpg";
import ProstateImage from "../../assets/final-images/aboutpage/Featured_Services/Artboard 5.jpg";
import womensImage from "../../assets/final-images/aboutpage/Featured_Services/Artboard 6.jpg";
import CardiacImage from "../../assets/final-images/aboutpage/Featured_Services/Artboard 7.jpg";
import PIPImage from "../../assets/final-images/aboutpage/Featured_Services/Artboard 8.jpg";
import { Link, useLocation } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import abstruct from "../../assets/final-images/shapes/abstruct_2.png";
import Faqs from "../Faqs";

const AboutAllContent = () => {
  const imgContainerRef = useRef(null);
  const hospitalImgRef = useRef(null);
  useEffect(() => {
    const topImage = imgContainerRef.current;
    const hospitalImage = hospitalImgRef.current;
    gsap.to(topImage, {
      width: "100%",
      borderRadius: "0px",
      marginTop: "0rem",
      ease: "none",
      scrollTrigger: {
        trigger: topImage,
        start: "top 50%",
        end: "+=300",
        scrub: true,
      },
    });

    gsap.to(hospitalImage, {
      width: "100%",
      borderRadius: "0px",
      marginTop: "0rem",
      ease: "none",
      scrollTrigger: {
        trigger: hospitalImage,
        start: "top 50%",
        end: "+=300",
        scrub: true,
      },
    });

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  const { hash } = useLocation();

  useEffect(() => {
    // Function to attempt scrolling to the target element
    const scrollToHash = () => {
      if (hash) {
        const targetId = hash.replace("#", "");
        const element = document.getElementById(targetId);
        if (element) {
          // Calculate navbar height (adjust based on your navbar's actual height)
          const navbarHeight = 250; // Adjust this value as needed
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: "smooth",
          });
        } else {
          console.warn(`Element with ID ${targetId} not found`);
          // Scroll to top if hash is invalid
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        // Scroll to top if no hash
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    // Initial attempt
    scrollToHash();

    // Retry after a short delay to account for AOS or DOM rendering
    const timer = setTimeout(scrollToHash, 500);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [hash]);
  const faqs = [
    {
      question: "Who owns and operates Citrus Diagnostic Center?",
      answer:
        "Citrus Diagnostic Center is a physician-owned and radiologist-operated group practice. It was founded in the 1980s and continues to be led by board-certified radiologists who are directly involved in patient care. Unlike large hospital systems or private equity-owned imaging chains, our practice is rooted in the local Crystal River community and focused entirely on delivering high-quality, patient-centered diagnostic imaging services.",
    },
    {
      question:
        "What credentials do the radiologists at Citrus Diagnostic Center hold?",
      answer:
        "The radiologists at Citrus Diagnostic Center hold M.D. degrees and are board-certified in diagnostic radiology. As the medical director and owner, our lead radiologist oversees all imaging operations, quality assurance, and report accuracy. Our team brings subspecialty expertise across multiple imaging modalities, ensuring that every study - from a routine chest X-ray to a complex nuclear medicine scan - is interpreted with precision and expertise.",
    },
    {
      question: "Is Citrus Diagnostic Center accredited?",
      answer:
        "Citrus Diagnostic Center operates in full compliance with state and federal regulations governing outpatient medical imaging facilities. Our equipment is regularly inspected and maintained to meet quality and safety standards. As a physician-operated practice, our radiologists are directly accountable for the quality and accuracy of every imaging interpretation we provide to patients and their referring physicians throughout Citrus County.",
    },
    {
      question:
        "How long has the radiologist been practicing in Citrus County?",
      answer:
        "Our lead radiologist has deep roots in the Citrus County community, with the practice having served Crystal River and the surrounding Nature Coast region since the 1980s. This multi-decade presence reflects our commitment to the health of local patients and our enduring relationships with the physicians and medical community throughout Citrus County, Hernando County, and Levy County.",
    },
    {
      question:
        "Why should I choose Citrus Diagnostic Center over a hospital radiology department?",
      answer:
        "Choosing Citrus Diagnostic Center over a hospital-based radiology department typically means lower costs, shorter wait times, and a more personal experience. Because we are a physician-owned, independent practice - not a large hospital system - our overhead is lower, which translates to significant cost savings for patients and insurers. You will still receive the same high-quality imaging and expert radiologist interpretation, but in a more comfortable, efficient outpatient setting right here in Crystal River, Florida.",
    },
  ];
  return (
    <>
      <div>
        <div className="text-center xl:pb-24 xl:pt-44">
          {" "}
          <h1 className="font-heading lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal pt-4 capitalize">
            About Citrus Diagnostic Center
          </h1>
          <p className=" text-[#cccccc] font-normal  font-robout">
            Built on experience. Guided by expertise.
          </p>
        </div>
        <div className="lg:w-[90%] w-[95%] mx-auto lg:py-16 py-8 ">
          <div
            className="  bg-[#0F0F0F] rounded-xl xl:p-24 py-10 "
            id="history"
          >
            <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize text-center xl:pb-24 pb-10">
              Founding & Legacy
            </h2>
            <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-24 gap-10">
              <div className="xl:bg-[#000] rounded-xl xl:p-8 px-5">
                <div className="text-[#cccccc]">
                  <p className="py-2">
                    Citrus Diagnostic Center has served the Citrus County
                    community since the 1980s, initially operating as a general
                    imaging facility during an early era of outpatient
                    diagnostic imaging.
                  </p>
                  <p className="py-2">
                    The practice was later acquired and fundamentally
                    transformed by{" "}
                    <span className="font-extrabold text-nowrap">
                      {" "}
                      Kamalesh Amin, MD,
                    </span>{" "}
                    a board-certified radiologist whose vision reshaped the
                    center into a{" "}
                    <span className="font-extrabold">
                      radiologist-led, academically grounded imaging practice.
                    </span>
                  </p>
                  <p className="py-2">
                    Dr. Amin was among the early adopters of advanced imaging in
                    the region, introducing technologies traditionally limited
                    to academic medical centers-including CT, MRI, PET, and
                    cardiac nuclear medicine-into a community-based setting. His
                    leadership emphasized diagnostic rigor, clinical relevance,
                    and independence at a time when advanced imaging was still
                    emerging outside major institutions.
                  </p>
                  <p className="py-2">
                    Under his direction, the center evolved from a general
                    imaging facility into a{" "}
                    <span className="font-extrabold">
                      comprehensive, radiologist-owned practice
                    </span>
                    , expanding its capabilities to include{" "}
                    <span className="font-extrabold">
                      advanced vascular imaging, women’s imaging, and a full
                      spectrum of diagnostic services
                    </span>
                    , while maintaining a focus on objective, clinically driven
                    care.
                  </p>
                  <p className="py-2">
                    That transformation defined the identity of Citrus
                    Diagnostic Center and continues to guide the practice today.
                  </p>
                </div>
              </div>
              <div className="flex flex-col justify-center items-left px-5 xl:px-0 ">
                <img
                  src={dr_image}
                  alt="Dr Kamlesh Amin Founder of Citrus Diagnostic Center Florida"
                  className="w-auto h-auto rounded-3xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="lg:py-20 md:py-16 py-10"
        style={{
          backgroundImage:
            "linear-gradient(to right, #3D0E26 0%, #8B5E3C 50%, #330A16 100%)",
        }}
      >
        <div className="lg:w-[90%] w-[95%] mx-auto  ">
          <div
            className=" justify-center items-center xl:p-24 py-10  bg-[#0f0f0f] rounded-xl"
            id="leadership"
          >
            <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize xl:pb-24 pb-10 text-center ">
              Current Leadership
            </h2>
            <div className="grid xl:grid-cols-2 grid-cols-1  xl:gap-24 gap-10 ">
              <div className=" flex justify-center items-center p-5 xl:p-0">
                <img
                  src={dr_samir}
                  alt="Dr Samir k Amin MD of Citrus Diagnostic Center Florida"
                  className="w-auto h-auto rounded-3xl"
                />
              </div>
              <div className="xl:bg-[#000] rounded-xl xl:p-8 px-5">
                <div className="text-[#cccccc]">
                  <p className="py-2">
                    Today, Citrus Diagnostic Center is led by{" "}
                    <span className="font-extrabold">Samir Amin, MD</span>, a
                    board-certified diagnostic radiologist with fellowship
                    training and subspecialized expertise in advanced MRI,
                    PET-CT, prostate imaging, and non-invasive cardiac imaging.
                  </p>
                  <p className="py-2">
                    A native of Citrus County, Dr. Amin returned to the
                    community where he was raised to continue and expand the
                    radiologist-led imaging practice established by his father.
                    Building on decades of independent radiology leadership, he
                    has strengthened and modernized the center while preserving
                    its core principles:{" "}
                    <span className="font-extrabold">
                      diagnostic rigor, independence, and patient-centered
                      decision-making.
                    </span>
                  </p>
                </div>
                <div className="text-[#cccccc]">
                  <p className="mt-2">
                    Under his leadership, Citrus Diagnostic Center has:
                  </p>
                  <ul className="  flex flex-col gap-3  pt-2.5  text-left font-robout">
                    <li className="flex items-start gap-2">
                      {" "}
                      <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                      Expanded advanced MRI capabilities, including wide-bore
                      high-field and open-bore MRI
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                      Strengthened PET-CT and molecular imaging programs across
                      oncology, prostate cancer, and neuroimaging
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                      Advanced cardiac and vascular imaging services
                    </li>
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                      Integrated modern AI and digital infrastructure to improve
                      image quality, workflow efficiency, and access-without
                      corporatization
                    </li>
                  </ul>
                </div>
                <div className="text-[#cccccc] pt-5">
                  <p className="py-2">
                    Dr. Amin’s approach reflects a belief that imaging is a{" "}
                    <span className="font-extrabold">
                      medical specialty requiring expertise, judgment, and
                      accountability
                    </span>{" "}
                    and that innovation should always serve clinical clarity and
                    patient choice.
                  </p>
                  <p className="mt-2">
                    Under his leadership, the practice has expanded its
                    capabilities while remaining true to its founding
                    principles:
                  </p>
                  <ul className="flex flex-col gap-3  pt-2.5  text-left font-robout">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e]" />{" "}
                      Radiologist ownership and independence
                    </li>
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e]" />{" "}
                      Evidence-based imaging decisions
                    </li>
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e]" /> Patient
                      choice and transparency
                    </li>
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e]" />{" "}
                      Continuous modernization without corporatization
                    </li>
                  </ul>
                </div>
                <div className="pt-8 flex flex-col md:flex-row items-center gap-3">
                  <Link
                    aria-label="About Chief Medical Officer page"
                    to="/chief-medical-officer"
                    className="px-8 py-2.5 rounded-3xl font-medium bg-white text-black
               hover:bg-black hover:border hover:text-white
               border border-[#ffffff5d] transition-all duration-300"
                  >
                    Meet Our CMO
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#0F0F0F] py-16 flex flex-col justify-center items-center">
        <h2 className=" text-center px-5 lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize  ">
          Why Citrus Diagnostic Center
        </h2>
        <div className="grid xl:grid-cols-2 grid-cols-1 3xl:gap-20 gap-10 justify-center items-center lg:w-[90%] w-[95%]  3xl:px-24 py-12 rounded-xl ">
          <div className="bg-[#000000] flex items-center rounded-xl p-8 ">
            <div className="flex flex-col 3xl:gap-6 gap-4">
              <div className=" flex flex-col gap-2">
                <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal  ">
                  Radiologist-Owned & Operated
                </h3>
                <p className="text-[#cccccc]   ">
                  Not corporate. Not private equity. No self-referral.
                </p>
              </div>
              <div className=" flex flex-col gap-2">
                <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal ">
                  Referral-Based Practice
                </h3>
                <p className="text-[#cccccc]   ">
                  Your physician’s order. Your choice.
                </p>
              </div>
              <div className=" flex flex-col gap-2">
                <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal  ">
                  Research-Grade Technology
                </h3>
                <p className="text-[#cccccc]   ">
                  The same systems used at universities and academic medical
                  centers.
                </p>
              </div>
              <div className=" flex flex-col gap-2">
                <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal ">
                  AI-Enhanced Imaging
                </h3>
                <p className="text-[#cccccc]   ">
                  Sharper images. Lower radiation. Smarter workflows.
                </p>
              </div>
            </div>
          </div>
          <div className=" flex justify-center items-center rounded-3xl xl:px-0 px-5 ">
            <img src={fatguy} alt="PET-CT scans" className=" rounded-3xl" />
          </div>
        </div>
        <div className="grid xl:grid-cols-2 grid-cols-1 3xl:gap-20 gap-10 justify-center items-center lg:w-[90%] w-[95%]  3xl:px-24 pb-12  rounded-xl">
          <div className="xl:order-1 order-2 flex justify-center items-center xl:px-0 px-5  rounded-3xl">
            <img src={care} alt="mri scans" className="rounded-3xl" />
          </div>
          <div className=" bg-[#000000] flex items-center 1 xl:order-2 order-1  rounded-3xl p-8">
            <div className="flex flex-col 3xl:gap-6  gap-4 ">
              <div className=" flex flex-col gap-2">
                <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal  ">
                  Expert Interpretation
                </h3>
                <p className="text-[#cccccc]   ">
                  All studies are interpreted by board-certified radiologists
                  with subspecialty expertise.
                </p>
              </div>
              <div className="flex flex-col gap-2">
                <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal  ">
                  Patient Choice & Transparency
                </h3>
                <p className="text-[#cccccc]   ">
                  Patients have the right to choose where imaging is performed
                  and who interprets their studies. We support informed choice
                  through education-not pressure.
                </p>
              </div>
              <div className="flex flex-col gap-2">
                <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal  ">
                  Comfort, Safety & Trust
                </h3>
                <p className="text-[#cccccc]   ">
                  Radiologist-tailored imaging protocols, personalized
                  preparation, radiation stewardship, and secure digital access
                  to results-all designed around the patient experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className=" w-full flex justify-center items-center overflow-hidden pb-16 ">
        <div
          ref={imgContainerRef}
          style={{
            width: "60%",
            borderRadius: "24px",
            marginTop: "4rem",
            backgroundImage:
              "linear-gradient(to right, #3D0E26 0%, #8B5E3C 50%, #330A16 100%)",
          }}
          className="overflow-hidden mx-auto bg-[#000000]"
        >
          <img
            src={top_img}
            alt="Diagnostic Center"
            className="object-contain w-full "
          />
        </div>
      </div>

      <div
        style={{
          backgroundImage:
            "linear-gradient(to right, #3D0E26 0%, #8B5E3C 50%, #330A16 100%)",
        }}
      >
        <div className="2xl:w-[90%] w-[95%] mx-auto py-14 ">
          <div
            className=" justify-center items-center py-14 bg-[#0F0F0F] rounded-xl"
            id="featured-services"
          >
            <h2 className=" text-center px-5 lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize ">
              Featured Imaging Services
            </h2>
            <div>
              <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-11/12 mx-auto  p-10 rounded-xl justify-center items-center">
                <div>
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  px-2 md:px-0 pb-5 ">
                    MRI
                  </h2>
                  <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal ">
                    Wide-Bore High-Field MRI. Comfort without compromise.
                  </h3>
                  <p className="py-2">
                    {" "}
                    Advanced MRI across neuroimaging, spine, musculoskeletal,
                    body, and prostate imaging-performed on modern Siemens
                    systems with an open, patient-centered design.
                  </p>
                  <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal pt-2">
                    Open & Bariatric MRI (80-cm Open-Bore MRI)
                  </h3>
                  <p className="py-2">
                    One of the most spacious MRI designs available, built for
                    claustrophobic and bariatric patients while maintaining
                    diagnostic-quality imaging.
                  </p>
                  <i>
                    <p className="py-2">
                      Claustrophobic or anxious? Our open-bore MRI offers a more
                      spacious experience without sacrificing image quality.
                    </p>
                  </i>
                </div>
                <div className="flex justify-center items-center rounded-xl">
                  <img
                    src={MRIABD}
                    alt="MRI"
                    className="rounded-3xl w-auto h-auto "
                  />
                </div>
              </div>
              <div
                style={{
                  background:
                    "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
                }}
                className="grid xl:grid-cols-2 grid-cols-1 gap-16 md:max-w-[90%] w-11/12 mx-auto p-10 rounded-xl justify-center items-center"
              >
                <div className="flex justify-center items-center order-2 xl:order-1  ">
                  <img
                    src={PETImage}
                    alt="PET Scans"
                    className="rounded-3xl w-auto h-auto "
                  />
                </div>
                <div className="order-1 xl:order-2 ">
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  px-2 md:px-0 ">
                    PET-CT
                  </h2>
                  <p className="] text-[#cccccc] font-normal pb-5  ">
                    Molecular imaging guided by experience.
                  </p>
                  <p className="py-2">
                    {" "}
                    PET-CT imaging for oncology, prostate cancer, neuroendocrine
                    tumors, and Alzheimer’s disease-interpreted by radiologists
                    with deep expertise in molecular imaging.
                  </p>
                  <p className="py-2">
                    {" "}
                    Citrus Diagnostic Center was built on a legacy of PET and
                    nuclear medicine excellence, with roots in early academic
                    PET adoption. PET imaging here is radiologist-led from
                    protocol to interpretation.
                  </p>
                </div>
              </div>
              <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-full mx-auto p-10 rounded-xl justify-center items-center">
                <div>
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  px-2 md:px-0 ">
                    Prostate Imaging
                  </h2>
                  <p className=" text-[#cccccc] font-normal pb-5 ">
                    Precision that guides confident decisions.
                  </p>
                  <p className="py-2">
                    {" "}
                    A comprehensive prostate imaging program integrating
                    multiparametric Prostate MRI with advanced prostate PET
                    imaging, interpreted by fellowship-trained expertise.
                  </p>
                  <p className="py-2">
                    {" "}
                    Prostate imaging is not one test-it’s an integrated
                    strategy.
                  </p>
                </div>
                <div className="flex justify-center items-center">
                  <img
                    src={ProstateImage}
                    alt="Prostate imaging "
                    className="rounded-3xl w-auto h-auto"
                  />
                </div>
              </div>
              <div
                style={{
                  background:
                    "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
                }}
                className="grid xl:grid-cols-2 grid-cols-1 gap-16 md:max-w-[90%] w-11/12 mx-auto p-10 rounded-xl justify-center items-center"
              >
                <div className="flex justify-center items-center order-2 xl:order-1 ">
                  <img
                    src={womensImage}
                    alt="Women imaging"
                    className="rounded-3xl w-auto h-auto"
                  />
                </div>
                <div className="order-1 xl:order-2 ">
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  px-2 md:px-0 ">
                    Women’s Imaging
                  </h2>
                  <p className=" text-[#cccccc] font-normal ">
                    Focused on early detection. Designed around you.
                  </p>
                  <p className="py-5">
                    {" "}
                    3D mammography, breast ultrasound, and breast MRI, supported
                    by personalized risk assessment and compassionate
                    care-delivered with attention to comfort, safety, and
                    clarity.
                  </p>
                </div>
              </div>
              <div className="grid xl:grid-cols-2 grid-cols-1 gap-16 md:max-w-[90%] w-11/12 mx-auto p-10 rounded-xl justify-center items-center">
                <div className="">
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  px-2 md:px-0  ">
                    Cardiac & Vascular Imaging
                  </h2>
                  <p className=" text-[#cccccc] font-normal pb-5">
                    See disease earlier. Act with confidence.
                  </p>
                  <p className="py-2">
                    {" "}
                    Advanced, non-invasive imaging including coronary CT
                    angiography, CT calcium scoring, echocardiography, cardiac
                    nuclear medicine, and comprehensive vascular ultrasound
                    screening.
                  </p>
                  <p className="py-2">
                    {" "}
                    Independent, radiologist-led imaging supports objective
                    cardiovascular assessment-free from treatment-driven bias.
                  </p>
                </div>
                <div className="flex justify-center items-center">
                  <img
                    src={CardiacImage}
                    alt="Cardiac & Vascular Imaging"
                    className="rounded-3xl w-auto h-auto"
                  />
                </div>
              </div>
              <div
                style={{
                  background:
                    "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
                }}
                className="grid xl:grid-cols-2 grid-cols-1 gap-16 md:max-w-[90%] w-11/12 mx-auto p-10 rounded-xl justify-center items-center"
              >
                <div className="flex justify-center items-center order-2 xl:order-1 ">
                  <img
                    src={PIPImage}
                    alt="Personal Injury / Workers' Compensation"
                    className="rounded-3xl w-auto h-auto"
                  />
                </div>
                <div className="order-1 xl:order-2 ">
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  px-2 md:px-0 pb-2 ">
                    Personal Injury / Workers' Compensation
                  </h2>
                  <p className="pb-1">
                    Auto Accident Injury Imaging / Personal Injury Protection
                    (PIP) Imaging / Slip and Fall Injury Imaging / Attorney LOP
                    Imaging
                  </p>
                  <p className=" text-[#cccccc] pb-5 font-normal ">
                    Diagnostic reliability when details matter.
                  </p>
                  <p className="py-2">
                    {" "}
                    Multimodality trauma imaging-including MRI, CT, X-ray,
                    ultrasound, and nuclear medicine-performed in permanent,
                    purpose-built imaging suites designed for consistent image
                    quality.
                  </p>
                  <p className="py-2">
                    {" "}
                    We provide concierge coordination for attorneys, referring
                    providers, and patients, with secure digital image sharing
                    and records delivery.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="flex justify-center items-center  lg:py-20 mb-10"
        style={{
          background: `url(${abstruct})`,
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
        }}
      >
        <div
          id="accreditations"
          className="lg:w-[90%] w-[95%] mx-auto flex flex-col xl:gap-5 gap-8 pb-10 items-center backdrop-blur-md "
          style={{
            background: "linear-gradient(#ffffff0d 0%, #ffffff14 100%)",
          }}
        >
          <div className=" text-center flex justify-center items-center  flex-col xl:gap-10 2xl:gap-2 gap-2 pt-10 text-[#f5f5f5] ">
            <div className="2xl:text-6xl xl:text-[2.75rem] text-4xl   text-center  mb-6 font-robout">
              <h2
                data-aos="fade-up"
                className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize"
              >
                ACCREDITATIONS
              </h2>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-10 justify-items-center items-start px-4 sm:px-6 lg:px-10 py-8">
              {[
                { img: imaging_acc_2, title: "CT", alt: "Accredited for CT" },
                {
                  img: imaging_acc_3,
                  title: "MAMMOGRAPHY",
                  alt: "Accredited for MAMMOGRAPHY",
                },
                { img: imaging_acc_1, title: "MRI", alt: "Accredited for MRI" },
                {
                  img: imaging_acc_4,
                  title: "NUCLEAR MEDICINE",
                  alt: "Accredited for NUCLEAR MEDICINE",
                },
                { img: imaging_acc_5, title: "PET", alt: "Accredited for PET" },
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center justify-center text-center gap-2 sm:gap-3"
                >
                  <img
                    src={item.img}
                    alt={item.alt}
                    className="w-20 sm:w-24 md:w-28 lg:w-32 object-contain"
                  />

                  <p className="font-heading text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] leading-snug text-[#cccccc]">
                    {item.title}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-center items-center">
            <div
              style={{
                background: `
              linear-gradient(90deg,
            #3d0e26 0%,
            #5a1f33 1%,
            #8b5e3c 40%,
            #8b5e3c 70%,
            #5a1f33 95%,
            #330a16 100%
          )
            `,
              }}
              className="flex justify-center items-center xl:w-[668px] flex-col py-8 px-6 xl:px-8 rounded-xl"
            >
              <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading texc  capitalize  ">
                Experience the Difference.
              </h2>
              <p className=" pt-5 ">
                Independent imaging. Expert interpretation. Patient-first care.
              </p>
              <div className="pt-10 pb-5">
                <Link
                  data-aos="fade-up"
                  to="/contact-us"
                  aria-label="Schedule Now"
                  className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold text-[17px] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
                >
                  Schedule Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center pb-20 mb-10">
        <div
          id="accreditations"
          className="lg:w-[80%] w-[90%] mx-auto  xl:gap-5 gap-8  items-center "
        >
          <Faqs faqs={faqs} />
        </div>
      </div>
    </>
  );
};

export default AboutAllContent;
